import script from "./notJoin.vue?vue&type=script&setup=true&lang=js"
export * from "./notJoin.vue?vue&type=script&setup=true&lang=js"

import "./notJoin.vue?vue&type=style&index=0&id=67ca3b8a&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ca3b8a"]])

export default __exports__